// EN — the SOURCE catalogue. One flat map, composed from one module per
// namespace.
//
// Every key the app can ask for is DECLARED here and translated in fa.js. A
// fa-only key is a defect; tests/i18n.test.js asserts parity in both directions.
//
// The split into ./en/<namespace>.js is the same one fa.js explains at length:
// one file per namespace so that the patients, chat and visit screens can be
// written at the same time without two authors editing one map. ./en/chat.js
// and ./en/visit.js belong to the chat and visit authors; add keys to the
// namespace you own and to no other.
//
// The exported shape is unchanged — a flat map of fully-qualified dotted keys —
// so catalogs.js, translator.js and the tests are untouched by the split.

import { common } from './en/common.js';
import { nav } from './en/nav.js';
import { login } from './en/login.js';
import { onboarding } from './en/onboarding.js';
import { patients } from './en/patients.js';
import { record } from './en/record.js';
import { chat } from './en/chat.js';
import { visit } from './en/visit.js';
import { credits } from './en/credits.js';
import { profile } from './en/profile.js';
import { errors } from './en/errors.js';

export const en = {
  ...common,
  ...nav,
  ...login,
  ...onboarding,
  ...patients,
  ...record,
  ...chat,
  ...visit,
  ...credits,
  ...profile,
  ...errors,
};

export default en;
